import AppDispatcher from 'dispatcher/MgfDispatcher';
import { MapStore } from 'flux/utils';
import { ActionTypes } from 'constants/MgfConstants';
import Immutable from 'immutable';
import WebUtils from 'util/WebUtils';
import languagesBo from 'constants/languages_bo.json';

class AuthStore extends MapStore {
  getInitialState() {
    let userId = localStorage.getItem('userId');
    const email = localStorage.getItem('email');
    const login = localStorage.getItem('login');
    let admin = localStorage.getItem('admin');
    let subAdmin = localStorage.getItem('subAdmin');
    let operationsAccess = localStorage.getItem('operationsAccess');
    let hotel = localStorage.getItem('hotel');
    let member = localStorage.getItem('member');
    const role = localStorage.getItem('role');
    const role2 = localStorage.getItem('role2');
    const salesKey = localStorage.getItem('salesKey');
    const area = localStorage.getItem('area');
    const partnerId = localStorage.getItem('partnerId');
    const tempAccess = localStorage.getItem('tempAccess');
    const ctoolMpa = localStorage.getItem('ctoolMpa');
    const initialPassed = localStorage.getItem('initialPassed');
    const introPassed = localStorage.getItem('introPassed');
    const myperfectapp = localStorage.getItem('myperfectapp');
    const mypersonalguide = localStorage.getItem('mypersonalguide');
    const corporateCtool = localStorage.getItem('corporateCtool');
    const corporateCtoolApp = localStorage.getItem('corporateCtoolApp');
    const chatNodeId = localStorage.getItem('chatNodeId');
    const faqNodeId = localStorage.getItem('faqNodeId');
    const newsNodeId = localStorage.getItem('newsNodeId');
    const contractStatus = localStorage.getItem('contractStatus');
    let goAfterLogin = localStorage.getItem('goAfterLogin');
    const allowPartnersIds = localStorage.getItem('allowPartnersIds');
    const subappsAllowed = localStorage.getItem('subappsAllowed');
    const demo = localStorage.getItem('demo');
    const loginTs = localStorage.getItem('loginTs');
    // const profileFilled = localStorage.getItem('profileFilled');
    const needToPay = localStorage.getItem('needToPay');
    if (hotel) {
      try {
        hotel = JSON.parse(hotel);
      } catch (err) { hotel = {}; }
    }
    if (admin) {
      try {
        admin = JSON.parse(admin);
      } catch (err) { admin = {}; }
    }
    if (subAdmin) {
      try {
        subAdmin = JSON.parse(subAdmin);
      } catch (err) { subAdmin = {}; }
    }
    if (operationsAccess) {
      try {
        operationsAccess = JSON.parse(operationsAccess);
      } catch (err) { operationsAccess = {}; }
    }
    if (member) {
      try {
        member = JSON.parse(member);
      } catch (err) { member = {}; }
    }
    if (userId === 'undefined') userId = null;
    if (goAfterLogin === 'undefined') goAfterLogin = '/mob';
    const auth = {
      userId, email, login, partnerId, admin, subAdmin, operationsAccess, member, goAfterLogin, tempAccess, ctoolMpa, initialPassed, introPassed, myperfectapp, mypersonalguide, corporateCtool, corporateCtoolApp, chatNodeId, faqNodeId, newsNodeId, contractStatus, /* profileFilled, */ needToPay, role, role2, salesKey, area, allowPartnersIds, subappsAllowed, demo, loginTs,
    };
    this._localeReset(this.getLang());
    return Immutable.fromJS({ auth: Immutable.fromJS(auth), hotel: Immutable.fromJS(hotel) });
  }

  getUserId() {
    if (this.get('auth')) {
      let { userId } = this.get('auth').toJS();
      if (userId === 'undefined') userId = null;
      return userId;
    }
    return null;
  }

  getName() {
    if (this.get('auth')) {
      const fn = this.get('auth').toJS().firstName;
      const ln = this.get('auth').toJS().lastName;
      return `${fn || ''} ${ln || ''}`;
    }
    return '';
  }

  getEmail() {
    if (this.get('auth')) {
      return this.get('auth').toJS().email;
    }
  }

  getLogin() {
    if (this.get('auth')) {
      let { login } = this.get('auth').toJS();
      if (!login || login === '' || login === 'null') login = this.get('auth').toJS().email;
      return login;
    }
  }

  getPartnerId() {
    if (this.get('auth')) {
      try {
        const { partnerIds = [] } = this.isSubAdmin() ? this.get('auth').toJS().subAdmin : this.get('auth').toJS().admin;
        return partnerIds[0];
      } catch (e) {}
    }
  }

  getAdmin() {
    if (this.get('auth')) {
      const auth = this.get('auth').toJS();
      if (auth.subAdmin && auth.subAdmin.partnerIds && auth.subAdmin.partnerIds.length) return auth.subAdmin;
      return auth.admin;
    }
  }

  isSubAdmin() {
    if (this.get('auth')) {
      const subAdmin = this.get('auth').toJS().subAdmin;
      return subAdmin && subAdmin.partnerIds && subAdmin.partnerIds.length;
    }
    return false;
  }

  getOperationsAccess() {
    if (this.get('auth')) {
      const operationsAccess = this.get('auth').toJS().operationsAccess;
      return operationsAccess || {};
    }
    return {};
  }

  getMember() {
    if (this.get('auth')) {
      return this.get('auth').toJS().member;
    }
  }

  getGoAfterLogin() {
    if (this.get('auth')) {
      /* temporary solution for switch CP to new landing page */
      let { goAfterLogin } = this.get('auth').toJS();
      if (!goAfterLogin) goAfterLogin = '';
      if ((this.getRole() === 'cooperationpartner' || this.getRole() === 'infopartner')
        && goAfterLogin.indexOf('cp-landing') === -1 && goAfterLogin.indexOf('/NodeTree/CTOOL/{}') === -1
      ) {
        AppDispatcher.dispatch({
          actionType: ActionTypes.LOGOUT,
        });
      }
      return goAfterLogin;
    }
  }

  getTempAccess() {
    if (this.get('auth')) {
      return this.get('auth').toJS().tempAccess;
    }
  }

  isCtoolMpa() {
    if (this.get('auth')) {
      const ctoolMpa = this.get('auth').toJS().ctoolMpa;
      return ctoolMpa === true || ctoolMpa === 'true';
    }
    return false;
  }

  isInitialPassed() {
    if (this.get('auth')) {
      const initialPassed = this.get('auth').toJS().initialPassed;
      return initialPassed === true || initialPassed === 'true';
    }
    return false;
  }

  isIntroPassed() {
    if (this.get('auth')) {
      const introPassed = this.get('auth').toJS().introPassed;
      return introPassed === true || introPassed === 'true';
    }
    return false;
  }

  isMyperfectapp() {
    if (this.get('auth')) {
      const myperfectapp = this.get('auth').toJS().myperfectapp;
      return myperfectapp === true || myperfectapp === 'true';
    }
    return false;
  }

  isMypersonalguide() {
    if (this.get('auth')) {
      const mypersonalguide = this.get('auth').toJS().mypersonalguide;
      return mypersonalguide === true || mypersonalguide === 'true';
    }
    return false;
  }

  isCorporateCtool() {
    if (this.get('auth')) {
      const corporateCtool = this.get('auth').toJS().corporateCtool;
      return corporateCtool === true || corporateCtool === 'true';
    }
    return false;
  }

  isCorporateCtoolApp() {
    if (this.get('auth')) {
      const corporateCtoolApp = this.get('auth').toJS().corporateCtoolApp;
      return corporateCtoolApp === true || corporateCtoolApp === 'true';
    }
    return false;
  }

  getChatNodeId() {
    if (this.get('auth')) {
      let chatNodeId = this.get('auth').toJS().chatNodeId;
      if (chatNodeId && chatNodeId.length !== 24) chatNodeId = undefined;
      return chatNodeId;
    }
    return false;
  }

  getFaqNodeId() {
    if (this.get('auth')) {
      let faqNodeId = this.get('auth').toJS().faqNodeId;
      if (faqNodeId && faqNodeId.length !== 24) faqNodeId = undefined;
      return faqNodeId;
    }
    return false;
  }

  getNewsNodeId() {
    if (this.get('auth')) {
      let newsNodeId = this.get('auth').toJS().newsNodeId;
      if (newsNodeId && newsNodeId.length !== 24) newsNodeId = undefined;
      return newsNodeId;
    }
    return false;
  }

  getContractStatus() {
    if (this.get('auth')) {
      return Number(this.get('auth').toJS().contractStatus);
    }
  }

  /*
  getProfileFilled() {
    return localStorage.getItem('profileFilled') === 'true';
  }
  */

  getNeedToPay() {
    return localStorage.getItem('needToPay') === 'true';
  }

  getRole() {
    if (this.get('auth')) {
      return this.get('auth').toJS().role;
    }
  }

  getRole2() {
    if (this.get('auth')) {
      return this.get('auth').toJS().role2;
    }
  }

  getSalesKey() {
    if (this.get('auth')) {
      return this.get('auth').toJS().salesKey;
    }
  }

  getArea() {
    if (this.get('auth')) {
      return this.get('auth').toJS().area;
    }
  }

  getHotel() {
    if (this.get('hotel')) {
      return this.get('hotel').toJS();
    }
    return '';
  }

  getAllowPartnersIds() {
    if (this.get('auth')) {
      return this.get('auth').toJS().allowPartnersIds;
    }
  }

  getSubappsAllowed() {
    if (this.get('auth')) {
      const subappsAllowed = Number(this.get('auth').toJS().subappsAllowed);
      return Number.isNaN(subappsAllowed) ? 0 : subappsAllowed;
    }
  }

  getDemo() {
    if (this.get('auth')) {
      const demo = Number(this.get('auth').toJS().demo);
      return Number.isNaN(demo) ? undefined : demo;
    }
  }

  getLoginTs() {
    if (this.get('auth')) {
      const loginTs = Number(this.get('auth').toJS().loginTs);
      return Number.isNaN(loginTs) ? new Date().getTime() : loginTs;
    }
  }

  getBrowserLang() {
    let lang = '';
    if (navigator.languages !== undefined) { lang = navigator.languages[0]; }
    lang = navigator.language;
    if (lang.length >= 2) return lang.slice(0, 2);
    return lang;
  }

  getLang() {
    let lang = WebUtils.getCookie('lang') || localStorage.getItem('lang') || this.getBrowserLang();
    const langs = languagesBo.map((l) => l.name);
    if (!langs.includes(lang)) {
      const { 0: firstLangBo = { name: 'en' } } = languagesBo;
      lang = firstLangBo.name;
    }
    return lang;
  }

  setLang(lang) {
    WebUtils.setCookie('lang', lang);
    localStorage.setItem('lang', lang);
    /*
    const url = `/${lang}/translations`;
    const response = await axios.get(url, { headers: { lang } });
    if (response && response.data) {
      try {
        eval(response.data)
        console.log(response.data);
      } catch (e) {
        console.log(e);
      };
    }
    */
  }

  isLogged() {
    const token = WebUtils.getCookie('token') || localStorage.getItem('token');
    return !!(token && token.length > 0);
  }

  _localeReset() {
    const cookieLang = WebUtils.getCookie('lang') || localStorage.getItem('lang');
    if (!cookieLang) {
      const navLang = navigator.language || navigator.userLanguage;
      if (navLang.indexOf('en') === 0 || navLang.indexOf('de') === 0 || navLang.indexOf('ru') === 0) {
        this.setLang(navLang.substring(0, 2));
      } else {
        this.setLang('en');
      }
    }

    // var pathname = window.location.pathname
    // var paths = pathname.split('/')
    // var lang = paths.length>0?paths[1]:'en'
    // var isOk = false
    // for (var i=0;i<languages.length;i++) {
    //  if (languages[i].name === lang) {
    //    isOk = true
    //    break
    //  }
    // }
    // if (!isOk){
    //  lang = 'en'
    //  this.setLang(lang)
    //  window.location.pathname='/en/'
    // } else {
    //  if (lang !== locale) {
    //    this.setLang(lang)
    //  }
    // }
  }

  _localeRedirect() {
    window.location.reload(true);
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.AUTH:
        sessionStorage.setItem('userId', action.auth.userId);
        localStorage.setItem('userId', action.auth.userId);
        localStorage.setItem('firstName', action.auth.firstName);
        localStorage.setItem('lastName', action.auth.lastName);
        localStorage.setItem('email', action.auth.email);
        localStorage.setItem('login', action.auth.login);
        localStorage.setItem('partnerId', action.auth.partnerId);
        localStorage.setItem('admin', JSON.stringify(action.auth.admin));
        localStorage.setItem('subAdmin', JSON.stringify(action.auth.subAdmin));
        localStorage.setItem('operationsAccess', JSON.stringify(action.auth.operationsAccess));
        localStorage.setItem('member', JSON.stringify(action.auth.member));
        localStorage.setItem('tempAccess', action.auth.tempAccess);
        localStorage.setItem('ctoolMpa', action.auth.ctoolMpa);
        localStorage.setItem('initialPassed', action.auth.initialPassed);
        localStorage.setItem('introPassed', action.auth.introPassed);
        localStorage.setItem('myperfectapp', action.auth.myperfectapp);
        localStorage.setItem('mypersonalguide', action.auth.mypersonalguide);
        localStorage.setItem('corporateCtool', action.auth.corporateCtool);
        localStorage.setItem('corporateCtoolApp', action.auth.corporateCtoolApp);
        localStorage.setItem('chatNodeId', action.auth.chatNodeId);
        localStorage.setItem('faqNodeId', action.auth.faqNodeId);
        localStorage.setItem('newsNodeId', action.auth.newsNodeId);
        localStorage.setItem('contractStatus', action.auth.contractStatus);
        localStorage.setItem('goAfterLogin', action.auth.goAfterLogin);
        localStorage.setItem('role', action.auth.role);
        localStorage.setItem('role2', action.auth.role2);
        localStorage.setItem('salesKey', action.auth.salesKey);
        localStorage.setItem('area', action.auth.area);
        localStorage.setItem('allowPartnersIds', action.auth.allowPartnersIds);
        localStorage.setItem('subappsAllowed', action.auth.subappsAllowed);
        localStorage.setItem('demo', action.auth.demo);
        localStorage.setItem('loginTs', action.auth.loginTs);
        let auth = {
          userId: action.auth.userId,
          firstName: action.auth.firstName,
          lastName: action.auth.lastName,
          email: action.auth.email,
          login: action.auth.login,
          partnerId: action.auth.partnerId,
          admin: action.auth.admin,
          subAdmin: action.auth.subAdmin,
          operationsAccess: action.auth.operationsAccess,
          member: action.auth.member,
          tempAccess: action.auth.tempAccess,
          ctoolMpa: action.auth.ctoolMpa,
          initialPassed: action.auth.initialPassed,
          introPassed: action.auth.introPassed,
          myperfectapp: action.auth.myperfectapp,
          mypersonalguide: action.auth.mypersonalguide,
          corporateCtool: action.auth.corporateCtool,
          corporateCtoolApp: action.auth.corporateCtoolApp,
          chatNodeId: action.auth.chatNodeId,
          faqNodeId: action.auth.faqNodeId,
          newsNodeId: action.auth.newsNodeId,
          contractStatus: action.auth.contractStatus,
          // profileFilled: false,
          needToPay: false,
          goAfterLogin: action.auth.goAfterLogin,
          role: action.auth.role,
          role2: action.auth.role2,
          salesKey: action.auth.salesKey,
          area: action.auth.area,
          allowPartnersIds: action.auth.allowPartnersIds,
          subappsAllowed: action.auth.subappsAllowed,
          demo: action.auth.demo,
          loginTs: action.auth.loginTs,
        };
        return this.getState().set('auth', Immutable.fromJS(auth));
      case ActionTypes.LOGOUT:
        sessionStorage.removeItem('userId');
        localStorage.removeItem('userId');
        localStorage.removeItem('role');
        localStorage.removeItem('role2');
        localStorage.removeItem('salesKey');
        localStorage.removeItem('area');
        localStorage.removeItem('tempAccess');
        localStorage.removeItem('ctoolMpa');
        localStorage.removeItem('initialPassed');
        localStorage.removeItem('introPassed');
        // DO NOT REMOVE since HAS NO AFFECT IF USER IS LOGGED IN
        // localStorage.removeItem('myperfectapp');
        // localStorage.removeItem('mypersonalguide');
        // localStorage.removeItem('corporateCtool');
        // localStorage.removeItem('corporateCtoolApp');
        localStorage.removeItem('chatNodeId');
        localStorage.removeItem('faqNodeId');
        localStorage.removeItem('newsNodeId');
        localStorage.removeItem('contractStatus');
        // localStorage.removeItem('profileFilled');
        localStorage.removeItem('needToPay');
        localStorage.removeItem('goAfterLogin');
        localStorage.removeItem('admin');
        localStorage.removeItem('subAdmin');
        localStorage.removeItem('operationsAccess');
        localStorage.removeItem('allowPartnersIds');
        localStorage.removeItem('subappsAllowed');
        localStorage.removeItem('demo');
        localStorage.removeItem('loginTs');
        WebUtils.rmvCookie('token');
        localStorage.removeItem('token');
        auth = {
          logged: false,
          userId: null,
          email: undefined,
          login: undefined,
          admin: undefined,
          subAdmin: undefined,
          operationsAccesssubAdmin: undefined,
          member: undefined,
          tempAccess: false,
          ctoolMpa: false,
          initialPassed: true,
          introPassed: true,
          myperfectapp: false,
          mypersonalguide: false,
          corporateCtool: false,
          corporateCtoolApp: false,
          chatNodeId: undefined,
          faqNodeId: undefined,
          newsNodeId: undefined,
          contractStatus: 0,
          // profileFilled: false,
          needToPay: false,
          goAfterLogin: '/mob',
          partnerId: undefined,
          role: undefined,
          role2: undefined,
          salesKey: undefined,
          area: undefined,
          allowPartnersIds: undefined,
          subappsAllowed: undefined,
          demo: undefined,
          loginTs: undefined,
        };
        return this.getState().set('auth', Immutable.fromJS(auth));
      case ActionTypes.CTOOL:
        localStorage.setItem('chatNodeId', action.auth.chatNodeId);
        localStorage.setItem('faqNodeId', action.auth.faqNodeId);
        localStorage.setItem('newsNodeId', action.auth.newsNodeId);
        return this.getState().mergeIn(['auth'], {
          chatNodeId: action.auth.chatNodeId,
          faqNodeId: action.auth.faqNodeId,
          newsNodeId: action.auth.newsNodeId,
        });
      case ActionTypes.SET_USER_LANGUAGE:
        this.setLang(action.lang);
        this._localeRedirect(this.getLang());
        return this.getState().setIn(['auth', 'lang'], action.lang);
      case ActionTypes.ADD_PARTNERID:
        let allowPartnersIds = localStorage.getItem('allowPartnersIds');
        if (!allowPartnersIds || allowPartnersIds === '') allowPartnersIds = action.partnerId;
        else allowPartnersIds = `${allowPartnersIds},${action.partnerId}`;
        localStorage.setItem('allowPartnersIds', allowPartnersIds);
        return this.getState().setIn(['auth', 'allowPartnersIds'], allowPartnersIds);
      case ActionTypes.ACCEPT_CONTRACT:
        localStorage.setItem('contractStatus', action.contractStatus);
        return this.getState().setIn(['auth', 'contractStatus'], action.contractStatus);
      case ActionTypes.INITIAL_PASSED:
        localStorage.setItem('initialPassed', action.initialPassed);
        return this.getState().setIn(['auth', 'initialPassed'], action.initialPassed);
      case ActionTypes.INTRO_PASSED:
        localStorage.setItem('introPassed', action.introPassed);
        return this.getState().setIn(['auth', 'introPassed'], action.introPassed);
      /*
      case ActionTypes.FILL_PROFILE:
        localStorage.setItem('profileFilled', action.profileFilled);
        return this.getState().setIn(['auth', 'profileFilled'], action.profileFilled);
      */
      case ActionTypes.NEED_TO_PAY:
        localStorage.setItem('needToPay', action.needToPay);
        return this.getState().setIn(['auth', 'needToPay'], action.needToPay);
      case ActionTypes.ALLOWPARTNERSIDS:
        localStorage.setItem('allowPartnersIds', action.allowPartnersIds);
        return this.getState().setIn(['auth', 'allowPartnersIds'], action.allowPartnersIds);
      case ActionTypes.HOTEL_ID_SET:
        const hotel = {
          id: action.hotelId,
          partnerId: action.partnerId,
        };
        localStorage.setItem('hotel', JSON.stringify(hotel));
        return this.getState().set('hotel', Immutable.fromJS(hotel));
      default:
        return this.getState();
    }
  }
}

export default new AuthStore(AppDispatcher);
